import script from "./TestPage.vue?vue&type=script&lang=ts&setup=true&name=test"
export * from "./TestPage.vue?vue&type=script&lang=ts&setup=true&name=test"

import "./TestPage.vue?vue&type=style&index=0&id=8e05af80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e05af80"]])

export default __exports__